import { GetStoryForEditorMeta, GetStoryForEditorPayload } from 'types/store/GetStoryForEditor';
import { createAsyncReducer } from 'utils/Redux';

import { getStoryForEditorActions } from '../actions';

export default createAsyncReducer<GetStoryForEditorMeta, GetStoryForEditorPayload>(getStoryForEditorActions);
